import { every, map } from 'lodash';
import { BaseController } from '../../../common/base/controller';
import { RequirementsRules } from './passwordRequirements.constants';

export class PasswordRequirementsCheckController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({
      controllerService,
    });
  }

  $onInit() {
    this.rules = RequirementsRules;
  }

  $onChanges(changeset) {
    const { password } = changeset;
    if (password) {
      this.checkRules(password.currentValue);
    }
  }

  checkRules(password) {
    map(this.rules, (rule) => {
      rule.valid = rule.regex.test(password);
    });

    const valid = every(this.rules, (r) => r.valid);
    this.onChange({ valid });
  }
}
